export default "__VITE_ASSET__fZGv3Vyt__"